import { Card, Statistic, Skeleton, Tooltip } from 'antd';
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import type { ReactNode } from 'react';

interface MetricCardProps {
  title: string;
  value: number | string;
  suffix?: string;
  prefix?: ReactNode;
  precision?: number;
  trend?: number;
  trendSuffix?: string;
  loading?: boolean;
  clickPath?: string;
  tooltip?: string;
  valueStyle?: React.CSSProperties;
}

export function MetricCard({
  title,
  value,
  suffix,
  prefix,
  precision = 0,
  trend,
  trendSuffix = '%',
  loading = false,
  clickPath,
  tooltip,
  valueStyle,
}: MetricCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (clickPath) {
      navigate(clickPath);
    }
  };

  const trendColor = trend !== undefined ? (trend >= 0 ? '#52c41a' : '#ff4d4f') : undefined;
  const TrendIcon = trend !== undefined ? (trend >= 0 ? ArrowUpOutlined : ArrowDownOutlined) : null;

  const cardTitle = (
    <span>
      {title}
      {tooltip && (
        <Tooltip title={tooltip}>
          <InfoCircleOutlined style={{ marginLeft: 8, color: '#999' }} />
        </Tooltip>
      )}
    </span>
  );

  return (
    <Card
      hoverable={!!clickPath}
      onClick={handleClick}
      style={{ cursor: clickPath ? 'pointer' : 'default' }}
    >
      {loading ? (
        <Skeleton active paragraph={false} />
      ) : (
        <Statistic
          title={cardTitle}
          value={value}
          precision={precision}
          prefix={prefix}
          suffix={
            <>
              {suffix}
              {trend !== undefined && TrendIcon && (
                <span style={{ marginLeft: 8, fontSize: 14, color: trendColor }}>
                  <TrendIcon />
                  {Math.abs(trend).toFixed(1)}{trendSuffix}
                </span>
              )}
            </>
          }
          valueStyle={valueStyle}
        />
      )}
    </Card>
  );
}
